// @core/api/endpoints/license/activate_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateLicenseRequest,
  LicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Activate license key
 * Activates a license key on the current platform instance. Verifies the cryptographic signature (Ed25519), validates hardware fingerprint binding, and enables the license.
 */
export async function ActivateLicense(
  data: ActivateLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/activate`;
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
